import React, { useState, useEffect, useRef } from 'react'
import { supabase } from '../../lib/supabase'

const Dashboard = () => {
  const [stats, setStats] = useState({
    tours: 0,
    applications: 0,
    newApplications: 0,
  })
  const isMounted = useRef(true)

  useEffect(() => {
    isMounted.current = true
    fetchStats()
    
    // Подписываемся на изменения
    const subscription = supabase
      .channel('dashboard-changes')
      .on('postgres_changes', 
        { event: '*', schema: 'public', table: 'tours' }, 
        () => {
          fetchStats()
        }
      )
      .on('postgres_changes', 
        { event: '*', schema: 'public', table: 'applications' }, 
        () => {
          fetchStats()
        }
      )
      .subscribe()
    
    return () => {
      isMounted.current = false
      subscription.unsubscribe()
    }
  }, [])

  const fetchStats = async () => {
    try {
      const { count: toursCount } = await supabase
        .from('tours')
        .select('*', { count: 'exact', head: true })
        .eq('status', 'active')
      
      const { count: appsCount } = await supabase
        .from('applications')
        .select('*', { count: 'exact', head: true })
      
      const { count: newAppsCount } = await supabase
        .from('applications')
        .select('*', { count: 'exact', head: true })
        .eq('status', 'new')
      
      if (isMounted.current) {
        setStats({
          tours: toursCount || 0,
          applications: appsCount || 0,
          newApplications: newAppsCount || 0,
        })
      }
    } catch (err) {
      console.error('Error fetching stats:', err)
    }
  }

  const cards = [
    { title: 'Активных туров', value: stats.tours, icon: '✈️', color: '#3b82f6' },
    { title: 'Всего заявок', value: stats.applications, icon: '📝', color: '#10b981' },
    { title: 'Новые заявки', value: stats.newApplications, icon: '🆕', color: '#f59e0b' },
  ]

  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1.5rem' }}>
        Панель управления
      </h1>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '1.5rem',
        marginBottom: '2rem'
      }}>
        {cards.map((card, index) => (
          <div key={index} style={{
            backgroundColor: 'white',
            borderRadius: '0.5rem',
            padding: '1.5rem',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <p style={{ color: '#6b7280', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
                  {card.title}
                </p>
                <p style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#1f2937' }}>
                  {card.value}
                </p>
              </div>
              <div style={{
                backgroundColor: card.color,
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5rem'
              }}>
                {card.icon}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div style={{
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        padding: '1.5rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '1rem' }}>
          Быстрые действия
        </h2>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <a
            href="/admin/tours/new"
            style={{
              display: 'inline-block',
              padding: '0.5rem 1rem',
              backgroundColor: '#3b82f6',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '0.375rem'
            }}
          >
            Добавить тур
          </a>
          <a
            href="/admin/applications"
            style={{
              display: 'inline-block',
              padding: '0.5rem 1rem',
              backgroundColor: '#10b981',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '0.375rem'
            }}
          >
            Просмотреть заявки
          </a>
        </div>
      </div>
    </div>
  )
}

export default Dashboard